import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import Link from "~/components/Link";
import { useSearchParams } from "~/components/navigation";
import { PageLoading } from "~/components/PageLoading";
import { WithStudentNav } from "~/components/WithStudentNav";
import { trpc } from "~/utils/trpc.client";
import { GoalMeasurementEditor } from "~/app/(new)/[teamId]/(with-student-nav)/students/[studentId]/goals/track/GoalMeasurementEditor";

export const Route = createFileRoute(
  "/_authed/$teamId/students/$studentId/goals/track",
)({
  component: GoalsDataPage,
});

function GoalsDataPage() {
  const { teamId, studentId } = Route.useParams();
  const searchParams = useSearchParams();
  const showAllDates = searchParams.get("showAllDates") === "true";

  const studentQuery = trpc.students.getStudent.useQuery({ id: studentId });

  const logStudentView = trpc.students.logStudentView.useMutation();
  useEffect(() => {
    logStudentView.mutate({ studentId });
    // run once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentId]);

  if (!studentQuery.data) {
    return (
      <WithStudentNav>
        <div className="mt-4 m-auto flex w-full max-w-[1000px] flex-col items-start gap-4 px-4">
          <PageLoading />
        </div>
      </WithStudentNav>
    );
  }

  const student = studentQuery.data;

  return (
    <WithStudentNav>
      <div className="mt-4 m-auto flex w-full max-w-[1000px] flex-col items-start gap-4 px-4">
        <div className="flex flex-row w-full">
          <div className="breadcrumbs text-sm overflow-visible">
            <ul>
              <li>
                <Link href={`/${teamId}`}>Team Home</Link>
              </li>
              <li>
                <Link href={`/${teamId}/students/${studentId}`}>
                  {student.name}
                </Link>
              </li>
              <li>
                <Link href={`/${teamId}/students/${studentId}/goals`}>
                  Goals
                </Link>
              </li>
              <li>
                <span>Track Goal Progress</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col gap-2 max-w-full">
          <div className="flex justify-between">
            <h1 className="text-2xl font-bold">Track Progress for Goals</h1>
            <div className="flex gap-2 flex-row-reverse">
              <Link
                href={`/${teamId}/students/${studentId}/goals/track${showAllDates ? "" : "?showAllDates=true"}`}
                className="btn btn-sm btn-secondary"
              >
                {showAllDates ? "Hide" : "Show"} All Dates
              </Link>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <GoalMeasurementEditor studentId={studentId} teamId={teamId} />
          </div>
        </div>
      </div>
    </WithStudentNav>
  );
}
